export default __webpack_public_path__ + "static/media/banner-site-agencias-mobile.e06c8c02.png";